// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ORd7","left":"styles_left__2NLyb","desktopActions":"styles_desktopActions__fBrBt","title":"styles_title__2Dy0Y"};